import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { GeoTreeLocation, GeoTreeLocationItem } from '@globals/types/GeoTree';

export interface LocationEntry {
	Value: string;
	Label: string;
};
export type LocationRegion = 'locationPlDl' | 'locationPlKp' | 'locationPlLbl' | 'locationPlLbs' | 'locationPlLd' | 'locationPlMp' | 'locationPlMz' | 'locationPlOp' | 'locationPlPk' | 'locationPlPdl' | 'locationPlPm' | 'locationPlSl' | 'locationPlSw' | 'locationPlWm' | 'locationPlWp' | 'locationPlZp';
export type LocationCountry = 'locationPl' | 'locationDe' | 'locationRus' | 'locationSk' | 'locationCz' | 'locationGb' | 'locationIrl' | 'locationAfg' | 'locationAl' | 'locationAnd' | 'locationAs' | 'locationA' | 'locationAz' | 'locationB' | 'locationBy' | 'locationBih' | 'locationBg' | 'locationChn' | 'locationHr' | 'locationCy' | 'locationMne' | 'locationCz' | 'locationDk' | 'locationEst' | 'locationFin' | 'locationF' | 'locationGr' | 'locationGe' | 'locationE' | 'locationNl' | 'locationInd' | 'locationIrq' | 'locationIr' | 'locationIrl' | 'locationIs' | 'locationCan' | 'locationKz' | 'locationKgz' | 'locationFl' | 'locationLt' | 'locationL' | 'locationLv' | 'locationMk' | 'locationM' | 'locationMa' | 'locationMd' | 'locationMc' | 'locationMn' | 'locationDe' | 'locationN' | 'locationSy' | 'locationP' | 'locationPl' | 'locationRus' | 'locationRo' | 'locationSrb' | 'locationSk' | 'locationSlo' | 'locationUsa' | 'locationSyr' | 'locationCh' | 'locationS' | 'locationTr' | 'locationTm' | 'locationUa' | 'locationUz' | 'locationH' | 'locationGb' | 'locationI';

export const useLocationStore = defineStore('location', () => {
	const state = {
		/**
		 * Lista identyfikatorów lokalizacji odpowiadającym krajom Unii Europejskiej
		 */
		locationEU: ref([
			'locationA',
			'locationB',
			'locationBg',
			'locationHr',
			'locationCy',
			'locationCz',
			'locationDk',
			'locationEst',
			'locationFin',
			'locationF',
			'locationGr',
			'locationE',
			'locationNl',
			'locationIrl',
			'locationLt',
			'locationLv',
			'locationL',
			'locationM',
			'locationDe',
			'locationP',
			'locationRo',
			'locationS',
			'locationSk',
			'locationSlo',
			'locationH',
			'locationI',
		]),

		countries: ref([
			{ Value: 'locationPl', Label: 'Polska' },
			{ Value: 'locationDe', Label: 'Niemcy' },
			{ Value: 'locationRus', Label: 'Rosja' },
			{ Value: 'locationSk', Label: 'Słowacja' },
			{ Value: 'locationCz', Label: 'Czechy' },
			{ Value: 'locationGb', Label: 'Wielka Brytania' },
			{ Value: 'locationIrl', Label: 'Irlandia' },
			{ Value: 'locationAfg', Label: 'Afganistan' },
			{ Value: 'locationAl', Label: 'Albania' },
			{ Value: 'locationAnd', Label: 'Andora' },
			{ Value: 'locationAs', Label: 'Arabia Saudyjska' },
			{ Value: 'locationA', Label: 'Austria' },
			{ Value: 'locationAz', Label: 'Azerbejdżan' },
			{ Value: 'locationB', Label: 'Belgia' },
			{ Value: 'locationBy', Label: 'Białoruś' },
			{ Value: 'locationBih', Label: 'Bośnia i Hercegowina' },
			{ Value: 'locationBg', Label: 'Bułgaria' },
			{ Value: 'locationChn', Label: 'Chiny' },
			{ Value: 'locationHr', Label: 'Chorwacja' },
			{ Value: 'locationCy', Label: 'Cypr' },
			{ Value: 'locationMne', Label: 'Czarnogóra' },
			{ Value: 'locationCz', Label: 'Czechy' },
			{ Value: 'locationDk', Label: 'Dania' },
			{ Value: 'locationEst', Label: 'Estonia' },
			{ Value: 'locationFin', Label: 'Finlandia' },
			{ Value: 'locationF', Label: 'Francja' },
			{ Value: 'locationGr', Label: 'Grecja' },
			{ Value: 'locationGe', Label: 'Gruzja' },
			{ Value: 'locationE', Label: 'Hiszpania' },
			{ Value: 'locationNl', Label: 'Holandia' },
			{ Value: 'locationInd', Label: 'Indie' },
			{ Value: 'locationIrq', Label: 'Irak' },
			{ Value: 'locationIr', Label: 'Iran' },
			{ Value: 'locationIrl', Label: 'Irlandia' },
			{ Value: 'locationIs', Label: 'Islandia' },
			{ Value: 'locationCan', Label: 'Kanada' },
			{ Value: 'locationKz', Label: 'Kazachstan' },
			{ Value: 'locationKgz', Label: 'Kirgistan' },
			{ Value: 'locationFl', Label: 'Liechtenstein' },
			{ Value: 'locationLt', Label: 'Litwa' },
			{ Value: 'locationL', Label: 'Luksemburg' },
			{ Value: 'locationLv', Label: 'Łotwa' },
			{ Value: 'locationMk', Label: 'Macedonia' },
			{ Value: 'locationM', Label: 'Malta' },
			{ Value: 'locationMa', Label: 'Maroko' },
			{ Value: 'locationMd', Label: 'Mołdawia' },
			{ Value: 'locationMc', Label: 'Monako' },
			{ Value: 'locationMn', Label: 'Mongolia' },
			{ Value: 'locationDe', Label: 'Niemcy' },
			{ Value: 'locationN', Label: 'Norwegia' },
			{ Value: 'locationSy', Label: 'Palestyna' },
			{ Value: 'locationP', Label: 'Portugalia' },
			{ Value: 'locationPl', Label: 'Polska' },
			{ Value: 'locationRus', Label: 'Rosja' },
			{ Value: 'locationRo', Label: 'Rumunia' },
			{ Value: 'locationSrb', Label: 'Serbia' },
			{ Value: 'locationSk', Label: 'Słowacja' },
			{ Value: 'locationSlo', Label: 'Słowenia' },
			{ Value: 'locationUsa', Label: 'Stany Zjednoczone' },
			{ Value: 'locationSyr', Label: 'Syria' },
			{ Value: 'locationCh', Label: 'Szwajcaria' },
			{ Value: 'locationS', Label: 'Szwecja' },
			{ Value: 'locationTr', Label: 'Turcja' },
			{ Value: 'locationTm', Label: 'Turkmenistan' },
			{ Value: 'locationUa', Label: 'Ukraina' },
			{ Value: 'locationUz', Label: 'Uzbekistan' },
			{ Value: 'locationH', Label: 'Węgry' },
			{ Value: 'locationGb', Label: 'Wielka Brytania' },
			{ Value: 'locationI', Label: 'Włochy' },
		]),

		poland: ref([
			{ Value: 'locationPlDl', Label: 'Dolnośląskie' },
			{ Value: 'locationPlKp', Label: 'Kujawsko-pomorskie' },
			{ Value: 'locationPlLbl', Label: 'Lubelskie' },
			{ Value: 'locationPlLbs', Label: 'Lubuskie' },
			{ Value: 'locationPlLd', Label: 'Łódzkie' },
			{ Value: 'locationPlMp', Label: 'Małopolskie' },
			{ Value: 'locationPlMz', Label: 'Mazowieckie' },
			{ Value: 'locationPlOp', Label: 'Opolskie' },
			{ Value: 'locationPlPk', Label: 'Podkarpackie' },
			{ Value: 'locationPlPdl', Label: 'Podlaskie' },
			{ Value: 'locationPlPm', Label: 'Pomorskie' },
			{ Value: 'locationPlSl', Label: 'Śląskie' },
			{ Value: 'locationPlSw', Label: 'Świętokrzyskie' },
			{ Value: 'locationPlWm', Label: 'Warmińsko-mazurskie' },
			{ Value: 'locationPlWp', Label: 'Wielkopolskie' },
			{ Value: 'locationPlZp', Label: 'Zachodniopomorskie' },
		]),

		districts: ref<Record<LocationRegion, LocationEntry[]>>({}),

		/**
		 * Style dla wybranych rejonów do kliknięcia
		 */
		googleMapStyles: {
			'default': {
				strokeWeight: 2,
				strokeColor: '#1462D3',
				fillColor: '#1462D3',
			},
			'false': {
				fillOpacity: 0.0,
				strokeOpacity: 0.15,
				strokeColor: '#808080',
			},
			'true': {
				fillOpacity: 0.25,
				strokeOpacity: 1.0,
				strokeColor: '#1462D3',
			},
			'blocked': {
				fillOpacity: 0.25,
				strokeOpacity: 1.0,
				strokeColor: '#808080',
				fillColor: '#808080',
			},
			'disabled': {
				fillOpacity: 0.25,
				strokeOpacity: 1.0,
				strokeColor: '#808080',
				fillColor: '#808080',
			},
			'false-readonly': {
				fillOpacity: 0.0,
				strokeOpacity: 0.15,
				strokeColor: '#808080',
			},
			'true-readonly': {
				fillOpacity: 0.25,
				strokeOpacity: 1.0,
				strokeColor: '#808080',
				fillColor: '#808080',
			},
		} as Record<string, {
			strokeWeight?: number;
			fillOpacity?: number;
			strokeOpacity?: number;
			strokeColor?: string;
			fillColor?: string;
		}>,
	};

	const actions = {
		async getDistrict(region: LocationRegion) {
			if (state.districts.value[region]) { return state.districts.value[region]; }
			let result = [] as LocationEntry[];
			const url = `/common/dictionary/zip/districts.ofer?zipSearch.idLocationExt=${region}`;
			await fetch(url).then((rsvp) => rsvp.text()).then((rsvp) => {
				const o = (new DOMParser()).parseFromString(rsvp, 'text/html').querySelectorAll('option');
				result = Array.prototype.map.call(o, (r) => ({ Value: r.value, Label: r.innerText.replace('powiat ', '') })) as LocationEntry[];
			});
			state.districts.value[region] = result;
			return result;
		},

		async growTree() {
			const getRootFromName = (name: string, tree: Record<string, GeoTreeLocation>) => {
				for (const root of Object.keys(tree)) {
					if (name.startsWith(root)) {
						return tree[root];
					}
				}
				return undefined;
			};
			const JSON_VERSION = 7;
			const JSON_PATH = `/scripts/geo.js?rev=${JSON_VERSION}`;
			const JSON_TREE_KEY = 'geotree';
			const treeFromLocalStorage = window.localStorage[JSON_TREE_KEY];
			if (treeFromLocalStorage) {
				const { data, version } = JSON.parse(treeFromLocalStorage) as {
					data: Record<string, GeoTreeLocation>;
					version: number;
				};
				const normalizedData = {} as Record<string, GeoTreeLocation>;
				Object.entries(data).forEach((group) => {
					const [key, values] = group;
					const normalizedValues = Object.entries(values).reduce((prev, current) => {
						const [valueKey, value] = current;
						const valueToLowerCase = valueKey.toLowerCase();
						if (valueToLowerCase === 'items') {
							Object.entries(value).forEach((entry) => {
								const [keyItems, valueItems] = entry as [string, GeoTreeLocationItem];
								const normalizedItemsValues = Object.entries(valueItems).reduce((prevItems, currentItems) => {
									const [itemsValueKey, itemsValue] = currentItems;
									const itemsValueToLowerCase = itemsValueKey.toLowerCase();
									return { ...prevItems, [itemsValueToLowerCase]: itemsValue };
								}, {});
								value[keyItems] = normalizedItemsValues;
							});
						}
						return { ...prev, [valueToLowerCase]: value };
					}, {});
					normalizedData[key] = normalizedValues as GeoTreeLocation;
				});
				if (version >= JSON_VERSION) {
					return normalizedData;
				}
			}
			const { countries, poland } = useLocationStore();
			const locs = {
				Countries: countries,
				Poland: poland,
			};
			const tree = {} as Record<string, GeoTreeLocation>;
			const domestic = locs.Poland;
			domestic.forEach(({ Value, Label }: { Value: string; Label: string }) => {
				tree[Value] = {
					name: Label,
					selected: 0,
					items: {},
					expanded: false,
				};
			});
			const foreign = locs.Countries;
			tree.locationForeign = {
				name: 'Zagranica',
				selected: 0,
				items: {},
				expanded: false,
			};
			foreign.forEach(({ Value, Label }: { Value: string; Label: string }) => {
				if (Value !== 'locationPl') {
					tree.locationForeign.items[Value] = {
						name: Label,
						selected: false,
					};
				}
			});
			const rsvp = await fetch(JSON_PATH).then((data) => data.json()) as Record<string, {
				name: string;
				geojson: { type: string; coordinates: unknown[] };
				cities: { v: string; n: string }[];
			}>;
			const set = (
				items: Record<string, GeoTreeLocationItem>,
				index: string,
				locationObject: GeoTreeLocationItem,
			) => {
				items[index] = locationObject;
			};
			for (const index in rsvp) {
				const location = rsvp[index];
				const root = getRootFromName(index, tree);
				if (!root) { continue; }
				set(root.items, index, {
					name: location.name,
					selected: false,
					geo: location.geojson,
				});
				if (!location.cities) {
					continue;
				}
				location.cities.forEach((city, cityIndex: number) => {
					const cityRoot = getRootFromName(city.v, tree);
					if (!cityRoot) { return; }
					set(cityRoot.items, city.v, {
						name: city.n,
						selected: false,
						geo: {
							type: 'Polygon',
							coordinates: [
								location.geojson.coordinates[Number(cityIndex) + 1],
							],
						},
					});
				});
			}
			window.localStorage[JSON_TREE_KEY] = JSON.stringify({
				version: JSON_VERSION,
				data: tree,
			});
			return tree;
		},

		updateTree(selected: string[], tree: Record<string, GeoTreeLocation>) {
			const locations = JSON.parse(
				// JSON.stringify(tree, (key, value) => (key === 'geo' ? undefined : value)),
				JSON.stringify(tree),
			);

			for (const index in locations) {
				const selectedAll = selected.indexOf(index) > -1;
				locations[index].expanded = locations[index].expanded || false;
				locations[index].selected = 0;

				if (selectedAll) {
					locations[index].selected = Object.keys(locations[index].items).length;
				}

				for (const itemIndex in locations[index].items) {
					if (selectedAll) {
						locations[index].items[itemIndex].selected = true;
						continue;
					}

					if (selected.indexOf(itemIndex) > -1) {
						locations[index].items[itemIndex].selected = true;
						locations[index].selected++;
					}

					// locations[index].geo = tree[index].items[itemIndex].geo;
				}
			}

			return locations;
		},

		toggleTreeLocation(locationName = '', tree: Record<string, GeoTreeLocation>) {
			const change = { items: [] as string[], select: false, disableReason: '' };
			const locationProperties = tree[locationName];

			if (locationProperties) {
				const areAllSelected = locationProperties.selected && locationProperties.selected === Object.keys(locationProperties.items).length;

				locationProperties.selected = areAllSelected ? 0 : Object.keys(locationProperties.items).length;
				change.select = !areAllSelected;

				for (const itemIndex in locationProperties.items) {
					locationProperties.items[itemIndex].selected = !areAllSelected;
					change.items.push(itemIndex);
				}
			} else {
				for (const index in tree) {
					const foundLocation = tree[index] && tree[index].items[locationName];

					if (foundLocation) {
						const isSelected = tree[index].items[locationName].selected;
						tree[index].items[locationName].selected = !isSelected;
						const selectedCount = Number(tree[index].selected);
						tree[index].selected = selectedCount + (isSelected ? -1 : 1);
						change.select = !isSelected;
						change.items.push(locationName);
					}
				}
			}

			// ...and cleanup this mess.
			const group = true;
			const result = [];

			for (const index in tree) {
				const areAllSelected = tree[index].selected && Object.keys(tree[index].items).length === tree[index].selected && group;

				const isSelected = tree[index].selected;

				if (areAllSelected && group && index !== 'locationForeign') {
					result.push(index);
					continue;
				}

				if (!isSelected) { continue; }

				for (const itemIndex in tree[index].items) {
					if (tree[index].items[itemIndex].selected) {
						result.push(itemIndex);
					}
				}
			}

			return { result, change };
		},
	};

	const getters = {
		foreignCountries: computed(() => state.countries.value.filter((country) => country.Value !== 'locationPl')),
		countriesByCode: computed(() => {
			const result = [] as LocationEntry[];
			state.countries.value.forEach((c) => {
				const countryCode = c.Value.replace('location', '').toUpperCase();
				result.push({ Value: countryCode, Label: `<span class="suggestions-list-hide">${countryCode}</span><span class="dropdown-button-hide">${c.Label}</span>` });
			});
			return result;
		}),
	};

	return { ...state, ...actions, ...getters };
});
